<template>
  <div class="peer-info-cell">
    <proa-avatar
      :src="avatar || require('@/assets/images/avatar_default.png')"
      :guest="guest"
      size="sm"
    />
    <span class="display-name">{{ displayName }}</span>
    <span v-show="isRaisedHands" class="state raised-hands">
      <img :src="require('@/assets/images/room/icons/raised_hands_sm.png')"/>
    </span>
    <span v-show="disabledMic" class="state">
      <img :src="require('@/assets/images/room/icons/mic_off_sm.png')"/>
    </span>
    <span v-show="disabledWebcam" class="state">
      <img :src="require('@/assets/images/room/icons/webcam_off_sm.png')"/>
    </span>
  </div>
</template>

<script>
export default {
  name: 'PeerInfoCell',
  props: {
    avatar: String,
    displayName: String,
    disabledMic: Boolean,
    disabledWebcam: Boolean,
    isRaisedHands: Boolean,
    guest: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.peer-info-cell {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .display-name {
    margin-left: 10px;
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 40%;
  }

  .state {
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border-radius: 50%;
    background-color: $secondary-color;
    display: flex;
    justify-content: center;
    align-items: center;

    &.raised-hands {
      background-color: #FF0000;
    }

    img {
      width: 14px;
      height: 14px;
    }
  }
}
</style>
